import { zergApi } from "@/service/zerg";

class TravelOrdersService {

    async getTravelOrders(params) {
        try {
            const data = await zergApi.get('/operations/travel-orders/index', { params });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getTravelOrderById(params) {
        try {
            const data = await zergApi.get('/operations/travel-orders/get-travel-order-by-id', { params });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getTravelOrdersForSelect(params) {
        try {
            const data = await zergApi.post('/operations/travel-orders/get-travel-orders-for-select', params);
            return data;
        } catch (error) {
            throw error;
        }
    }



    async getTravelOrderStatusEnum(params) {
        try {
            const data = await zergApi.post('/operations/travel-orders/get-travel-order-status-enum', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async registerTravelOrder(params) {
        try {
            const data = await zergApi.post('/operations/travel-orders/save', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async editTravelOrder(params) {
        try {
            const data = await zergApi.put('/operations/travel-orders/update', params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new TravelOrdersService();